import React from 'react';
import '../../styles/spots.css';

const AvailableSpotsSection = () => {
  // Data for each card
  const cardsData = [
    {
      id: 1,
      title: "Tineri 18-29 ani cu domiciliul în București-Ilfov",
      totalSpots: 950
    },
    {
      id: 2,
      title: "Tineri 18-29 ani din minoritatea romă, cu domiciliul în București-Ilfov",
      totalSpots: 300
    },
    {
      id: 3,
      title: "Tineri 18-29 ani cu domiciliul în regiunile mai puțin dezvoltate (fără București-Ilfov)",
      totalSpots: 13500
    },
    {
      id: 4,
      title: "Tineri 18-29 ani din minoritatea romă, cu domiciliul în regiunile mai puțin dezvoltate",
      totalSpots: 2850
    }
  ];

  return (
    <section className="spots" id="spots">
      <h2 className="section-title">Locuri alocate pe categorii</h2>
      
      <div className="spots-grid">
        {cardsData.map((card) => (
          <div key={card.id} className="spot-card">
            <p className="spot-text">{card.title}</p>
            <div className="spot-details">
              <div className="spot-total">
                <p className="spot-label">Locuri alocate în această sesiune</p>
                <p className="spot-number spot-number-total">{card.totalSpots.toLocaleString('ro-RO')}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-center text-sm text-gray-600 mt-6 px-4">Sursa: comunicarea MEDAT privind a doua sesiune Start-Up Nation, ediția a IV-a. Numărul de locuri rămase se vede doar pe minimis.imm.gov.ro.</p>
    </section>
  );
};

export default AvailableSpotsSection;